function Yard() {
  return (
    <section className="section yard-section" id="yard">
      <div className="container">

        <div className="section-head reveal">
          <p className="section-label">YARD</p>
          <h2 className="section-title">ヤード案内</h2>
          <p className="section-desc">
            ご来場前に所在地・営業時間をご確認ください。
          </p>
        </div>

        {/* ヤード① */}
        <div className="yard-card">

          <div className="yard-map">
            <iframe title="yard-map-1"
              src="https://www.google.com/maps?q=愛知県弥富市稲荷3丁目&output=embed"
              width="100%"
              height="300"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </div>

          <div className="yard-info">
            <h3>海上用コンテナ 弥富ヤード</h3>
            <p><span>住所</span>〒498-0052 愛知県弥富市稲荷3丁目</p>
            <p><span>営業時間</span>平日9時〜15時</p>
            <p><span>電話番号</span>0575-82-6870</p>
          </div>

        </div>

        {/* ヤード② */}
        <div className="yard-card">

          <div className="yard-map">
            <iframe title="yard-map-2"
              src="https://www.google.com/maps?q=愛知県弥富市東末広1丁目45-1&output=embed"
              width="100%"
              height="300"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </div>

          <div className="yard-info">
            <h3>名港ヤード</h3>
            <p><span>住所</span>愛知県弥富市東末広1丁目45-1</p>
            <p><span>営業時間</span>平日9時〜15時</p>
            <p><span>電話番号</span>0575-82-6870</p>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Yard;
